import React from 'react'

export default function Header({ leftIcon, children }) {
    if (leftIcon) {
        return <h4 className='mar-b25'><div style={{ display: 'inline-flex', marginRight: 10 }}>{leftIcon}</div>{children}</h4>
    }
    return (
        <h4 className='mar-b25'>{children}</h4>
    )
}